export default __webpack_public_path__ + "static/media/tete27.73b3335c.png";